import React from 'react';
import { CheckCircleIcon, ShieldIcon, TagIcon } from 'lucide-react';
export function PricingSection() {
  return <section className="py-16 bg-gradient-to-b from-white to-pink-50 px-4" data-id="element-122">
      <div className="container mx-auto max-w-6xl" data-id="element-123">
        <div className="text-center mb-12" data-id="element-124">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-125">
            Oferta de Lanzamiento
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-126">
            Invierte en tu futuro y comienza a generar ingresos haciendo lo que
            te apasiona
          </p>
        </div>
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-4xl mx-auto border-2 border-pink-200" data-id="element-127">
          <div className="bg-gradient-to-r from-pink-500 to-purple-600 p-6 text-white text-center" data-id="element-128">
            <TagIcon className="h-10 w-10 mx-auto mb-2" data-id="element-129" />
            <h3 className="text-2xl font-bold" data-id="element-130">
              ¡Precio Especial de Lanzamiento!
            </h3>
            <p className="opacity-90" data-id="element-131">Oferta por tiempo limitado</p>
          </div>
          <div className="p-8" data-id="element-132">
            <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-133">
              <div data-id="element-134">
                <p className="text-gray-500 mb-1" data-id="element-135">Valor total:</p>
                <p className="text-2xl font-bold line-through text-gray-400" data-id="element-136">
                  $150.000
                </p>
              </div>
              <div className="text-right" data-id="element-137">
                <p className="text-pink-500 font-medium mb-1" data-id="element-138">Hoy solo:</p>
                <p className="text-4xl font-bold text-pink-600" data-id="element-139">$14.999</p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-140">
              <div className="flex items-start" data-id="element-141">
                <CheckCircleIcon className="h-6 w-6 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-142" />
                <span data-id="element-143">Acceso inmediato y de por vida</span>
              </div>
              <div className="flex items-start" data-id="element-144">
                <CheckCircleIcon className="h-6 w-6 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-145" />
                <span data-id="element-146">Certificado profesional al completar</span>
              </div>
              <div className="flex items-start" data-id="element-147">
                <CheckCircleIcon className="h-6 w-6 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-148" />
                <span data-id="element-149">Actualizaciones gratuitas</span>
              </div>
              <div className="flex items-start" data-id="element-150">
                <CheckCircleIcon className="h-6 w-6 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-151" />
                <span data-id="element-152">Soporte por email</span>
              </div>
            </div>
            <div className="bg-green-50 p-4 rounded-lg flex items-start mb-8" data-id="element-153">
              <ShieldIcon className="h-6 w-6 text-green-600 mt-0.5 mr-3 flex-shrink-0" data-id="element-154" />
              <div data-id="element-155">
                <h4 className="font-semibold text-green-800" data-id="element-156">
                  Garantía de satisfacción de 7 días
                </h4>
                <p className="text-green-700" data-id="element-157">
                  Si no estás 100% satisfecha, te devolvemos tu dinero. Sin
                  preguntas.
                </p>
              </div>
            </div>
            <a href="https://nailmasterclasspro.mitiendanube.com/checkout/v3/start/1789839156/b96e63bc245079acd7af9657978acace71d015a6?from_store=1&country=AR" className="bg-gradient-to-r from-pink-500 to-purple-600 text-white px-8 py-4 rounded-full text-lg font-bold shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 w-full inline-block text-center" data-id="element-158">
              QUIERO TRANSFORMAR MI FUTURO - $14.999
            </a>
          </div>
        </div>
      </div>
    </section>;
}